(() => {
  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    const cleanups = [];
    const sortForm = root.querySelector('[data-sort-form]');
    if (sortForm) {
      const onSortChange = event => {
        if (event.target.name !== 'sort_by') return;
        sortForm.querySelectorAll('.sort-option').forEach(option => option.classList.toggle('is-active', Boolean(option.querySelector('input:checked'))));
        sortForm.requestSubmit();
      };
      sortForm.classList.add('o2o-sort-is-enhanced');
      sortForm.addEventListener('change', onSortChange);
      cleanups.push(() => sortForm.removeEventListener('change', onSortChange));
    }

    const track = root.querySelector('[data-collection-category-track]');
    const active = track?.querySelector('[aria-current="page"]');
    if (active) track.scrollLeft = Math.max(0, active.offsetLeft - track.offsetLeft - (track.clientWidth - active.clientWidth) / 2);

    instances.set(root, () => {
      cleanups.forEach(cleanup => cleanup());
      instances.delete(root);
    });
  }

  function init(scope = document) {
    if (scope.matches?.('[data-collection-root]')) mount(scope);
    scope.querySelectorAll('[data-collection-root]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target === root || event.target.contains(root)) dispose();
  });
})();
